import { render, staticRenderFns } from "./DeclareList.vue?vue&type=template&id=7d99dd80&scoped=true&"
import script from "./DeclareList.vue?vue&type=script&lang=js&"
export * from "./DeclareList.vue?vue&type=script&lang=js&"
import style0 from "./DeclareList.vue?vue&type=style&index=0&id=7d99dd80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d99dd80",
  null
  
)

export default component.exports